import { render, staticRenderFns } from "./product_info.vue?vue&type=template&id=5b160a3a"
import script from "./product_info.vue?vue&type=script&lang=js"
export * from "./product_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b160a3a')) {
      api.createRecord('5b160a3a', component.options)
    } else {
      api.reload('5b160a3a', component.options)
    }
    module.hot.accept("./product_info.vue?vue&type=template&id=5b160a3a", function () {
      api.rerender('5b160a3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/reports/physical_promotion/form/product_info.vue"
export default component.exports